// src/stores/mainStore.js
import { defineStore } from 'pinia';

export const useStore = defineStore('mainStore', {
  state: () => ({
    areaId: 1,
    appBarComponents: [],
  }),
  actions: {
    setAreaId(newAreaId) {
      this.areaId = newAreaId; // Update the areaId in the store
      console.log('store id',this.areaId);
    },
    setAppBarComponents(components) {
        this.appBarComponents = components; // Update the app bar components
    },
  }
});